export const categories = [
  { slug: 'all', name: '全部福利', icon: 'ri-star-line' },
  { slug: 'free', name: '免费领取', icon: 'ri-gift-line' },
  { slug: 'coupon', name: '优惠券', icon: 'ri-coupon-line' },
  { slug: 'flash-sale', name: '限时秒杀', icon: 'ri-flashlight-line' },
  { slug: 'digital', name: '数码好物', icon: 'ri-smartphone-line' },
  { slug: 'food', name: '美食饮品', icon: 'ri-restaurant-line' },
  { slug: 'life', name: '生活日用', icon: 'ri-home-smile-line' },
  { slug: 'beauty', name: '美妆护肤', icon: 'ri-magic-line' },
];